import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@ifeng/public_method';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';

const Company = ({ content, companyTitleImage }) => {
    return (
        <div className={styles.company}>
            <Chip id="260726" title="企业专区标题图" groupName="中国力量" type="struct">
                <div className={styles.companyTitle}>
                    <img src={companyTitleImage} />
                </div>
            </Chip>
            <Chip id="287974" title="企业专区" groupName="中国力量" type="recommend">
                <div className={styles.companyBox}>
                    {content.slice(0, 6).map((item, index) => {
                        const imageUrl = item?.thumbnail || item?.thumbnails?.image?.[0]?.url || '';

                        return (
                            <a href={item.url} rel="noreferrer" key={index} target="_blank" className={styles.companyItem}>
                                <img className={styles.companyItemPic} src={formatImage(imageUrl, 155, 103)} />
                                <div className={styles.companyItemTitle}>{item.title}</div>
                            </a>
                        );
                    })}
                </div>
            </Chip>
        </div>
    );
};

Company.propTypes = {
    content: PropTypes.array,
    companyTitleImage: PropTypes.string,
};

export default errorBoundary(Company);
